import { c } from "node_modules/vite/dist/node/types.d-AKzkD8vd";
import { ReactNode } from "react";

export default function Index() {
  return (
    <div className="flex h-full w-full flex-col items-center bg-[#E3DACC]">
      <div className="text-bold mt-20 font-FKScreamer text-[100px] uppercase">
        Um Okkur
      </div>
      <div className="mx-6 mt-20 flex flex-col items-center text-center text-2xl font-semibold sm:mx-10 md:max-w-[1000px]">
        <Paragraph>
          Nola var stofnað sem vefverslun í mars 2014 og er í dag verslun,
          vefverslun og heildverslun. Við opnuðum verslun í Turninum, Höfðatorgi
          1.júlí 2016. Í nóvember 2018, fluttum við starfsemi okkar í Ármúla 38
          og erum þar enn. Við bjóðum uppá gæða snyrtivörur á sanngjörnu verði
          og er stefna okkar að vera með spennandi vörur sem standa uppúr á sínu
          sviði og bjóða viðskiptavinum okkar uppá framúrskarandi þjónustu. Við
          flytjum sjálf inn öll okkar vörumerki og fáum allar vörur beint frá
          birgja og erum því viðurkenndur sölu og dreifingaraðili fyrir öll
          okkar vörumerki. Við keppumst við að bjóða uppá vörumerki sem hafa
          ekki verið á íslenskum markaði.
        </Paragraph>
        <Paragraph>
          Allar okkar vörur eru Cruelty Free, án þekktra óæskilegra
          innihaldsefna, náttúrulegar, lífrænar, vegan og gluten free eða virkar
          vörur með vísindi á bakvið sig. Eigandi Nola er Karin Kristjana
          Hindborg, hún er menntaður förðunarfræðingur, naglafræðingur og með BA
          í sænsku, uppeldis og menntunarfræði frá Háskóla Íslands. Karin vinnur
          einnig sem sjálfstætt starfandi sminka. Nola lógóið hannaði Serious
          Business.
        </Paragraph>
      </div>
    </div>
  );
}

const Paragraph = ({ children }: { children: ReactNode }) => (
  <div className="my-2">{children}</div>
);
